import {makeStyles, fade} from "@material-ui/core";

const withStyles = makeStyles((theme) => ({
    paper: {
        marginTop: '1px',
        borderTop: `1px solid ${theme.palette.secondary.main}`,
        borderBottomLeftRadius: '5px',
        borderBottomRightRadius: '5px',
    },
    inputRoot: {
        padding: '0!important',
    },
    input: {
        padding: '30px 45px 14px 14px!important',
    },
    inputFlatted: {
        padding: '1rem!important'
    },
    popupIndicator: {
        right: theme.spacing(1),
    },
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
        fontFamily: 'NeoSansMedium',
    },
    listItemCode: {
        fontFamily: 'monospace',
        fontWeight: 'bolder',
        color: fade(theme.palette.primary.main, .5)
    },
    option: {
        '&[data-focus="true"]': {
            backgroundColor: fade(theme.palette.secondary.main, .1),
        },
        '&[aria-selected="true"]': {
            backgroundColor: fade(theme.palette.secondary.main, .15),
        },
    }
}));

export default withStyles;